import { ConfigType } from '../utils/requestAPI';

type CreateTechniciansJobDataType = {
  jobTitle?: string;
  notes?: string;
  building?: string;
  drawingSize?: string;
  frameColor?: string;
  logo?: string[];
  logoResolution?: string;
  drawingMaterialType?: string;
  roundedEdge?: boolean;
  pricing?: string;
  shippingAddress?: string;
  additionalRequirement?: {
    title: string;
    value: string;
  }[];
};

type GetTechniciansParamsType = {
  page?: number;
  limit?: number;
  search?: string;
};
type GetTechniciansAllParamsType = {
  page?: number;
  limit?: number;
  status?: string;
};
type ScheduleDataType = {
  year: string | Date;
  month: string | Date;
  status: string;
};
const techniciansJobApi = {
  createTechnician: (data: CreateTechniciansJobDataType): ConfigType => {
    return {
      url: '/technician-jobs/',
      method: 'post',
      data: data,
    };
  },
  updateTechnician: (
    jobId: string,
    data: CreateTechniciansJobDataType,
  ): ConfigType => {
    return {
      url: `/technician-jobs/${jobId}`,
      method: 'put',
      data: data,
    };
  },
  deleteTechnician: (jobId: string): ConfigType => {
    return {
      url: `/technician-jobs/${jobId}`,
      method: 'delete',
    };
  },
  getTechnicianJobs: (params: GetTechniciansParamsType): ConfigType => {
    return {
      url: '/technician-jobs/Client-Id',
      method: 'get',
      params,
      config: { store: { action: 'set', key: 'technicianJobs.data' } },
    };
  },
  getTechnicianJobsDetail: (id: string): ConfigType => {
    return {
      url: `/technician-jobs/${id}`,
      method: 'get',
      config: { store: { action: 'set', key: 'technicianJobsDetails' } },
    };
  },
  getTechnicianAllJobs: (params: GetTechniciansAllParamsType): ConfigType => {
    return {
      url: '/technician-jobs',
      method: 'get',
      params,
      config: { store: { action: 'set', key: 'technicianAllJobs.data' } },
    };
  },
  getSchedules: (params: ScheduleDataType): ConfigType => {
    return {
      url: '/job-process/schedule',
      method: 'get',
      params,
      config: { store: { action: 'set', key: 'technicianScheduleData.data' } },
    };
  },
};

export default techniciansJobApi;
